<template>
  <div id="app">
    <Header routeValue="0"></Header>
    <content class="content">
      <div class="waterfall" v-infinite-scroll="getMaterialList" :infinite-scroll-disabled="isLoading"
           :infinite-scroll-distance="10">
        <div v-for="item in dataList" class="waterfall-item" @mouseover="changeColor(item)"
             @mouseleave="resetColor(item)" @click="toDetailsDes(item)">
          <div class="img_box">
            <img
              :src="item.materialImgList[0].imgUrl| imgFilter(369)"
              alt="image"/>
          </div>
          <span :style="{ color: item.color }">{{ item.materialName }}</span>
        </div>

      </div>
      <a-spin v-show="isLoading"/>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import EventBus from '../router/event-bus.js'

export default {
  name: 'Product',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      title: '',
      dataList: [],
      options: [],
      isLoading: false,
      id: undefined,
      total: 1,
      pageNum: 1,
      pageSize: 20
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.title = window.location.href + 'design'
  },
  created () {
    this.id = this.$route.params.id || undefined
    EventBus.$on('customEvent', this.handleCustomEvent)
  },
  beforeDestroy () {
    EventBus.$off('customEvent', this.handleCustomEvent)
  },
  methods: {
    handleCustomEvent (data) {
      this.id = data
      this.pageNum = 1
      this.total = 1
      this.dataList = []
      this.getMaterialList()
    },
    getMaterialList () {
      if (this.isLoading || this.dataList.length >= this.total) {
        return
      }
      this.isLoading = true
      this.$http({
        method: 'post',
        url: `/api/material/list?pageNum=${this.pageNum}&pageSize=${this.pageSize}`,
        data: {mcId: this.id},
      }).then((res) => {
        this.dataList = this.dataList.concat(res.data.rows)
        this.total = res.data.total
        this.pageNum++
        this.dataList.forEach(item => {
          item['color'] = '#4C8EFF'
        })
        this.isLoading = false
      })
    },
    changeColor (item) {
      item.color = '#FF4A26'
      this.$forceUpdate()
    },
    resetColor (item) {
      item.color = '#4C8EFF'
      this.$forceUpdate()
    },
    toDetailsDes (item) {
      this.$router.push({path: `/designs/${item.id}`})
    },
  },
}
</script>
<style scoped lang="less">

.content {
  margin: 0 118px 0 157px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .waterfall {
    display: flex;
    flex-wrap: wrap;
    margin: 30px 0;

    .waterfall-item {
      display: flex;
      flex-direction: column;
      margin-right: 39px;
      margin-bottom: 29px;

      .img_box {
        width: 369px;
        height: 369px;
        display: flex;
        border: 1px solid #FFFFFF;
        justify-content: center;
        align-items: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      span {
        max-width: 369px;
        overflow: hidden; // 超出的文本隐藏
        text-overflow: ellipsis; // 溢出用省略号显示
        white-space: nowrap;
        font-weight: bold;
        font-size: 15px;
        color: #4C8EFF;
        margin-top: 11px;
        transition: color 0.3s; /* 添加颜色的过渡效果 */
      }

    }
  }

  .waterfall-item:hover {
    cursor: pointer; /* 鼠标悬停时显示手型光标 */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Design.vue